"use client";

import { useCookieConsent } from "@/contexts/CookieConsentContext";
import { Button } from "./Button";
import { useEffect, useState } from "react";
import { ShieldCheckIcon } from "@heroicons/react/24/outline";

export default function CookieConsentBanner() {
	const { setHasConsent } = useCookieConsent();
	const [showBanner, setShowBanner] = useState(false);

	useEffect(() => {
		// Show banner if user hasn't made a choice yet
		const consent = localStorage.getItem("cookieConsent");
		if (consent === null) {
			setShowBanner(true);
		}
	}, []);

	const saveConsentStats = async (action: "accepted" | "rejected") => {
		try {
			await fetch("/api/cookie-consent", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					action,
					userAgent: navigator.userAgent,
				}),
			});
		} catch (error) {
			console.error("Failed to save consent stats:", error);
		}
	};

	if (!showBanner) return null;

	return (
		<div className="fixed bottom-0 left-0 right-0 z-50 bg-base-100 shadow-lg border-t border-base-300 backdrop-blur-sm bg-opacity-95">
			<div className="container mx-auto px-4 py-4">
				<div className="flex flex-col sm:flex-row items-center justify-between gap-4">
					<div className="flex items-start gap-3">
						<div className="p-2 rounded-lg bg-primary/10 mt-1">
							<ShieldCheckIcon className="w-5 h-5 text-primary" />
						</div>
						<div className="text-sm text-base-content/80">
							<p className="mb-1 font-medium">We value your privacy</p>
							<p className="text-sm text-base-content/60">
								We use cookies to enhance your experience, analyze site traffic,
								and personalize content. By clicking &quot;Accept All&quot;, you
								agree to our use of cookies.{" "}
								<button
									onClick={() => {
										setHasConsent(false);
										setShowBanner(false);
										saveConsentStats("rejected");
									}}
									className="text-primary hover:underline text-xs font-medium transition-colors duration-200"
								>
									Reject All
								</button>{" "}
								<span className="text-xs text-base-content/60">or</span>{" "}
								<a
									href="/policies/privacy"
									className="text-primary hover:underline text-s font-medium transition-colors duration-200"
								>
									Learn More
								</a>
							</p>
						</div>
					</div>
					<div className="flex gap-3">
						<Button
							onClick={() => {
								setHasConsent(true);
								setShowBanner(false);
								saveConsentStats("accepted");
							}}
							className="text-sm font-medium px-6 bg-primary hover:bg-primary-focus text-primary-content transition-colors cursor-pointer"
						>
							Accept All
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
}
